// extracted by mini-css-extract-plugin
export default {"squirrelWidth":"Squirrel_squirrelWidth__nEip2","blinking":"Squirrel_blinking__xIIxv","blinker":"Squirrel_blinker__DQ25H"};